import moment from 'moment';
import dayDifferenceHelper from './dayDifferenceHelper';

// Presentation only: keep the billing engine's existing 7 / 28 day thresholds.
export function getDiscountOffers({ weeklyDiscount, monthlyDiscount } = {}) {
    return [
        { days: 7, percentage: Number(weeklyDiscount) },
        { days: 28, percentage: Number(monthlyDiscount) },
    ].filter(offer => Number.isFinite(offer.percentage) && offer.percentage > 0 && offer.percentage <= 100);
}

export function getDiscountDays({ startDate, endDate, startTime = 0, endTime = 0 } = {}) {
    if (!startDate || !endDate) return null;
    const start = moment(startDate), end = moment(endDate);
    if (!start.isValid() || !end.isValid() || end.isBefore(start, 'day')) return null;
    if (start.isSame(end, 'day') && Number(startTime) >= Number(endTime)) return null;
    const days = dayDifferenceHelper({ startDate, endDate, startTime, endTime });
    return Number.isFinite(days) && days > 0 ? days : null;
}

export function getDiscountPresentation(data = {}, days = null) {
    const offers = getDiscountOffers(data);
    if (!offers.length) return { offers, featured: null, next: null };
    if (!Number.isFinite(days) || days <= 0) {
        // Stable tie: show the more accessible threshold.
        const featured = offers.reduce((best, offer) => offer.percentage > best.percentage ? offer : best);
        return { offers, featured, next: null };
    }
    const next = offers.find(offer => offer.days > days) || null;
    // After the last threshold, mirror the existing monthly-first billing rule.
    const applied = offers.filter(offer => offer.days <= days).slice(-1)[0] || null;
    return { offers, featured: next || applied, next };
}
